import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APP_CONFIG } from 'app/core/config/app-config.token';
import { Observable } from 'rxjs';

export interface WhatsNewSection {
  readonly heading: string;
  readonly body: string;
}

export interface WhatsNewResponse {
  readonly title: string;
  readonly imageUrl: string | null;
  readonly sections: readonly WhatsNewSection[];
}

@Injectable({ providedIn: 'root' })
export class WhatsNewService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG);

  private get apiServerUri(): string {
    return this.appConfig.serverUrl;
  }

  /**
   * Fetches the current What's New content, relayed by the .NET API
   * from the WordPress Help Centre page.
   */
  get(): Observable<WhatsNewResponse> {
    const url = `${this.apiServerUri}/help/whatsNew`;
    return this.http.get<WhatsNewResponse>(url);
  }
}
